import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  translateMenu: (key: string) => string = () => '';
  translateChart: (key: string) => string = () => '';

  translateMenuItems(value: string): string {
    switch (value) {
      case 'Roles':
        return $localize`Roles`;
      case 'Users':
        return $localize`Users`;
    }
  }
}
